<template>
    <div class="booking-slide">
        <h3 class="w-full font-sans font-medium text-center text-blue-500 h2">
            {{ ui.details.heading }}
        </h3>
        <p v-if="ui.details.text" class="mt-6 font-normal text-center text-blue-500">
            {{ ui.details.text }}
        </p>

        <BaseLabel
            class="mt-5"
            text="First name (e.g., Timothy, not Tim)"
            :validation="$v.firstName"
        >
            <BaseInput v-model="firstName" type="text" />
        </BaseLabel>

        <BaseLabel class="mt-5" text="Last name" :validation="$v.lastName">
            <BaseInput v-model="lastName" type="text" />
        </BaseLabel>

        <div class="md:flex">
            <BaseLabel class="pt-4 md:w-1/2 md:pr-3" text="Date of birth" :validation="$v.dob">
                <DateInput v-model="dob" :required="true" />
            </BaseLabel>

            <BaseLabel
                class="pt-4 md:w-1/2 md:pl-3"
                text="Mobile number*"
                :validation="$v.phoneNumber"
            >
                <BaseInput v-model="phoneNumber" type="text" />
            </BaseLabel>
        </div>

        <BaseLabel class="mt-5" text="Membership number" :validation="$v.membershipNumber">
            <BaseInput v-model="membershipNumber" type="text" />
        </BaseLabel>

        <BaseLabel class="mt-5" text="Person number (see back of card)" :validation="$v.hicapsCode">
            <BaseInput v-model="hicapsCode" type="text" />
        </BaseLabel>

        <p class="mt-3 text-blue-500 small">
            *This number will override any mobile numbers in our system. We will use it as this
            member’s main contact number from now on.
        </p>

        <transition name="shrink">
            <div
                v-if="activeAlert"
                class="px-8 py-6 mt-6 text-red-500 bg-red-300 border-l-4 border-red-500 small"
            >
                <p class="mb-3 font-bold">Error</p>
                <p>
                    {{ activeAlert.text }}
                </p>
            </div>
        </transition>

        <button
            class="w-full mt-10 btn exception"
            :class="{
                'btn--loading text-transparent': isLoading
            }"
            @click="submit"
        >
            Continue
        </button>
    </div>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators';
import hydrateFromProps from '@/../vue/online-booking/mixins/hydrate-from-props';
import DateInput from '@/vue/components/DateInput.vue';
import BaseLabel from '@/../vue/_base/form/Label.vue';
import BaseInput from '@/../vue/_base/form/Input.vue';

export default {
    components: {
        BaseLabel,
        BaseInput,
        DateInput
    },

    mixins: [hydrateFromProps(['details'])],

    props: {
        serviceType: {
            type: String,
            required: true
        },
        details: {
            type: Object,
            default: () => {}
        },
        ui: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        alerts: {
            type: Array,
            required: true
        }
    },

    data: () => ({
        firstName: null,
        lastName: null,
        dob: null,
        phoneNumber: null,
        membershipNumber: null,
        hicapsCode: null
        // dob: '22/08/1992',
        // firstName: 'Dan',
        // lastName: 'Siberry',
        // mobileNumber: '34 652322716',
        // membershipNumber: 123123123,
        // hicapsCode: '123123abc'
    }),

    computed: {
        activeAlert() {
            return this.alerts.length && this.alerts[this.alerts.length - 1];
        }
    },

    methods: {
        submit() {
            this.$v.$touch();

            if (!this.$v.$invalid) {
                this.$emit('complete', this._data);
            }
        }
    },

    validations: {
        firstName: {
            required
        },
        lastName: {
            required
        },
        dob: {
            required,
            validDob: helpers.regex('validDob', /^\d{2}\/\d{2}\/[1|2]\d{3}$/)
        },
        phoneNumber: {
            required,
            validPhoneNumber: helpers.regex('validPhoneNumber', /^04\d{8}$/)
        },
        membershipNumber: {
            required
        },
        hicapsCode: {
            required
        }
    }
};
</script>
